import React from 'react';
import { ChakraV3 } from '..';

export const DividerWithContent = (props: React.PropsWithChildren<ChakraV3.StackProps>) => {
  const { children, ...rest } = props;

  return (
    <ChakraV3.Stack direction='row' alignItems='center' {...rest}>
      <ChakraV3.Separator flex='1' />
      <ChakraV3.Box flexShrink='0'>{children}</ChakraV3.Box>
      <ChakraV3.Separator flex='1' />
    </ChakraV3.Stack>
  );
};
